import { NotificationObjectEntityType } from '@/__generated__/graphql';
import { setModalDisplayedAnnouncement } from '@features/announcements/slices/announcementsSlice';

export const entitiesHandlers = {
  [NotificationObjectEntityType.Announcement]: {
    handleClickNotification: setModalDisplayedAnnouncement,
    handleShowNotificationModal: setModalDisplayedAnnouncement,
  },
} as const;
